import React from 'react';
import Mode from '../Enums/Mode';

export type ModeContextProps = {
    mode: Mode,
    setMode: (mode: Mode) => void,
};

const ModeContext: React.Context<ModeContextProps> = React.createContext<ModeContextProps>({
    mode: Mode.LOGIN,
    setMode: () => {},
});

export default ModeContext;